import { useSettings } from '../../store/settings';

const ALIGN = { left: 'text-left', center: 'text-center', right: 'text-right' } as const;

/** Text widget: the viewer's own heading and/or text (Settings → Widgets → Text). Line breaks are kept. */
export function TextNote() {
  const { heading, body, align, size } = useSettings((s) => s.text);
  const empty = !heading.trim() && !body.trim();
  return (
    <div className={`glass p-5 ${ALIGN[align] ?? ALIGN.left}`}>
      {/* zoom scales the whole note, including its rem-sized text, by the chosen size. */}
      <div style={{ zoom: size }}>
        {empty ? (
          <p className="muted text-sm">Add your text in Settings → Widgets → Text.</p>
        ) : (
          <>
            {heading.trim() && <h3 className="font-heading text-2xl font-semibold leading-snug">{heading}</h3>}
            {body.trim() && <p className={`whitespace-pre-wrap text-lg leading-relaxed ${heading.trim() ? 'mt-2' : ''}`}>{body}</p>}
          </>
        )}
      </div>
    </div>
  );
}
